import type { RouteObject } from 'react-router'

export const embedRoutes: RouteObject[] = [
  {
    path: '/embed/post/:id',
    async lazy() {
      const { PostEmbed } = await import('../client/embed/Post/index.js')

      return { Component: PostEmbed }
    },
  },
  {
    path: '/embed/event/:id',
    async lazy() {
      const { EventEmbed } = await import('../client/embed/Event/index.js')

      return { Component: EventEmbed }
    },
  },
  {
    path: '/embed/space/:slug',
    async lazy() {
      const { SpaceEmbed } = await import('../client/embed/Space/index.js')

      return { Component: SpaceEmbed }
    },
  },
]
